import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { Component } from "react";
import { ControlLabel } from "react-bootstrap";
import * as Yup from "yup";
import "../Shared/DateTime.css";
import FormikDatetime from "../Shared/FormikDateTime";


class EditForm extends Component {
  render() {
    console.log(this.props.item.at)
    const validationSchema = Yup.object().shape({
      location: Yup.string()
        .max(30, "maximum 30 characters").when('region', {
          is: (v) => v !== 'ZOOM_WEBINAR',
          then: Yup.string().required("Location is required"),
        }).nullable(),
      venue_track_as: Yup.string()
        .max(30, "maximum 30 characters")
        .required("Tracking key is required"),
      region: Yup.string()
        .required("Region is required"),
      address: Yup.string().max(100, "maximum 100 characters").when('region', {
          is: (v) => v !== 'ZOOM_WEBINAR',
          then: Yup.string().required("Address is required"),
        }).nullable(),
      zoom_join_url: Yup.string().max(100, "maximum 100 characters").when('region', {
          is: (v) => v === 'ZOOM_WEBINAR',
          then: Yup.string().required("Zoom Join URL is required"),
        }).nullable(),
      at: Yup.date().required("Must specify when"),
      capacity: Yup.number()
        .integer("Can't have part people")
        .min(1, "Must be more than 0")
        .max(500, "More than 500? Are you sure?")
        .required("Must specify when")
    })

    return (
      <div>
        {this.props.item ? (
          <div>
            <Formik
              initialValues={{
                location: this.props.item.location,
                zoom_join_url: this.props.item.zoom_join_url,
                venue_track_as: this.props.item.venue_track_as,
                address: this.props.item.address,
                capacity: this.props.item.capacity,
                at: this.props.item.at ? moment(this.props.item.at ) : moment(),
                status: this.props.item.status,
                region: this.props.item.region
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  this.props.updateSeminar(values);
                  setSubmitting(false);
                }, 400);
              }}
              render={({
                errors,
                touched,
                isSubmitting,
                values,
                setFieldValue,
                setFieldTouched
              }) => {
                // moment.tz.setDefault('Australia/Melbourne')
                return (
                  <Form>
                    <div className={`form-group ${errors.region && touched.region && "has-error"}`}>
                      <ControlLabel>Region or Webinar</ControlLabel>
                      <Field component="select" name="region" className="form-control" disabled={this.props.item.region}>
                        <option value=''>-- select --</option>
                        <option value="ACT">Australian Capital Territory (SSC)</option>
                        <option value="NSW">New South Wales (HSC)</option>
                        <option value="NT">Northern Territory (NTCET)</option>
                        <option value="QLD">Queensland (QCE)</option>
                        <option value="SA">South Australia (SACE)</option>
                        <option value="TAS">Tasmania (TCE)</option>
                        <option value="VIC">Victoria (VCE)</option>
                        <option value="WA">Western Australia (WACE)</option>
                        <option disabled value=''>-- webinars --</option>
                        <option value="ZOOM_WEBINAR">Zoom Webinar</option>
                      </Field>
                      <ErrorMessage name="region" component="span" className="help-block" />
                    </div>
                    {values.region && <div>

                      <div className='row'>
                        <div className='col-md-6'>
                          <div className={`form-group ${errors.location && touched.location && "has-error"}`}>
                            <ControlLabel>
                            {values.region === 'ZOOM_WEBINAR' ? 'Description of Webinar' : 'Location Name'}
                            </ControlLabel>
                            <Field type="text" name="location" className="form-control" />
                            <ErrorMessage name="location" component="span" className="help-block" />
                          </div>
                        </div>
                        {values.region === 'ZOOM_WEBINAR' && <div className='col-md-6'>
                          <div className={`form-group ${errors.zoom_join_url && touched.zoom_join_url && "has-error"}`}>
                            <ControlLabel>Zoom Join URL</ControlLabel>
                            <Field
                              type="text"
                              name="zoom_join_url" className="form-control"
                            />
                            <ErrorMessage
                              name="zoom_join_url"
                              component="span" className="help-block"
                            />
                          </div>
                        </div>}
                        {values.region !== 'ZOOM_WEBINAR' && <div className='col-md-6'>
                          <div className={`form-group ${errors.address && touched.address && "has-error"}`}>
                            <ControlLabel>Address</ControlLabel>
                            <Field
                              type="text"
                              name="address" className="form-control"
                            />
                            <ErrorMessage
                              name="address"
                              component="span" className="help-block"
                            />
                          </div>
                        </div>}
                      </div>

                      <div className='row'>

                        <div className='col-md-6'>

                          <div className={`form-group ${errors.venue_track_as && touched.venue_track_as && "has-error"}`}>
                            <ControlLabel>Track Venue As? (for analytics)</ControlLabel>
                            <Field
                              type="text"
                              name="venue_track_as"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="venue_track_as"
                              component="span"
                              className="help-block"
                            />
                          </div>
                        </div>
                      </div>

                      <div className='row'>
                        <div className='col-md-6'>
                          <div className={`form-group ${errors.at && touched.at && "has-error"}`}>
                            <ControlLabel>When</ControlLabel>
                            <FormikDatetime
                              field="at"
                              input={{
                                value: moment(values.at).format("DD MMM YYYY HH:mm"),
                                onChange: setFieldValue,
                                onBlur: setFieldTouched
                              }}
                              closeOnSelect={true}
                              dateFormat="DD MMM YYYY"
                              timeFormat="HH:mm"
                              // utc={true}
                              displayTimeZone={'Australia/Melbourne'}
                            />
                            <ErrorMessage name="at" component="span" className="help-block" />
                          </div>
                        </div>
                      </div>


                      <div className={`form-group ${errors.capacity && touched.capacity && "has-error"}`}>
                        <ControlLabel>Capacity</ControlLabel>
                        <Field
                          type="number"
                          name="capacity"
                          className="form-control"
                          style={{ width: "100px" }}
                          maxLength={3}
                        />
                        <ErrorMessage
                          name="capacity"
                          component="span"
                          className="help-block"
                        />
                      </div>

                      <div className={`form-group ${errors.status && touched.status && "has-error"}`}>
                        <ControlLabel>Status</ControlLabel>
                        <Field
                          component="select"
                          name="status"
                          className="form-control"
                        >
                          <option value="open">Open for Registration</option>
                          <option value="in_progress">Post Seminar Actions In Progress</option>
                          <option value="completed">Completed</option>
                          <option value="closed">Closed for Public Registration</option>
                          <option value="hidden">Closed for All Registration</option>
                          <option value="cancelled">Cancelled</option>
                        </Field>
                        <ErrorMessage
                          name="status"
                          component="span"
                          className="help-block"
                        />
                      </div>


                      <div style={{ marginTop: "20px" }}>
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="btn btn-primary"
                        >
                          Save Changes
                    </button>
                      </div>
                    </div>}
                  </Form>
                )
              }}
            />
          </div>
        ) : (
            <div />
          )}
      </div>
    );
  }
}
export default EditForm;
